import { FounderEvent } from '../types';

export const founderProfile = {
  name: 'Cuong Nguyen Manh',
  handle: 'atomixnmc / atomix',
  title: 'Founder, Software Architect & Creative Technologist',
  bio: 'Cuong is a seasoned software architect and creative technologist with extensive experience spanning 3D game engines, distributed systems, generative AI pipelines, and agentic development workflows. From core contributions in open-source graphics frameworks (jMonkeyEngine, LibGDX, Atom3D) to publishing indie games and pioneering AI video/VFX tools (uploop-vided, MCP multimedia engines), Cuong founded AtomixM (Mass & Multimedia) to synthesize code, generative soundscapes, cinematic storytelling, and vibe-coding architecture into one open ecosystem.',
  avatarUrl: 'https://avatars.githubusercontent.com/u/7083807?s=400',
  boothImage: '/images/brand/atomix-summit-booth.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/cuong-nguyen-manh-912139b1/',
  githubProfile: 'https://github.com/atomixnmc',
  gameOrg: 'https://github.com/atomixgame',
  devBlog: 'https://atomixnmc.github.io/mydevblog/',
  youtube: 'https://youtube.com/@atomixchannel',
  location: 'Atlanta, GA / Global',
  expertise: [
    'Software Architecture & System Design',
    '3D Game Engines & Real-Time Graphics (Vulkan, OpenGL, ECS)',
    'Generative AI Audio & Video Pipelines',
    'Model Context Protocol (MCP) & AI Agent Tooling',
    'Vibe Coding & Flow-State Engineering',
    'Open-Source Framework Engineering'
  ]
};

export const founderEvents: FounderEvent[] = [
  {
    year: '2026',
    title: 'Atlanta Comic Con & Game Developers Summit 2026',
    location: 'Atlanta, GA',
    role: 'Keynote Exhibitor & Workshop Host',
    description: 'Showcasing the unified AtomixM ecosystem: live demonstrations of Atom3D real-time game rendering, Suno-inspired AI audio pipelines, and preview screenings of AtomixFilms cinematic sci-fi shorts.',
    image: '/images/brand/atomix-summit-booth.jpg',
    badges: ['Keynote', 'AI Multimedia', 'Game Showcase', 'Live Vibe Coding']
  },
  {
    year: '2024',
    title: 'Atlanta Indie Game Summit & Comic Expo 2024',
    location: 'Atlanta, GA',
    role: 'Exhibitor & Open-Source Creator',
    description: 'Premiered early versions of AtomGdx and open-source game development tools to the Atlanta developer community, accompanied by initial experiments in AI generative algorithmic beats.',
    image: '/images/brand/atomix-summit-booth.jpg',
    badges: ['Open Source', 'Indie Games', 'Algorithmic Audio', 'Community']
  }
];
